export default __webpack_public_path__ + "static/media/add-user.74cc0908.svg";